import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const api = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const usePendingReviews = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "pendingReviews",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/reviews/pending`, api(token));
      return res.data.pending;
    },
    { enabled: !!token }
  );
};

export const useSubmitReview = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (data) => axios.post(`${process.env.REACT_APP_SERVER_URL}/customer/reviews`, data, api(token)),
    {
      onSuccess: () => {
        qc.invalidateQueries("pendingReviews");
      },
    }
  );
};

export const useOrderNotifications = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "orderNotifications",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/notifications`, api(token));
      return res.data.notifications;
    },
    { enabled: !!token }
  );
};

export const useInbox = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "customerInbox",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/inbox`, api(token));
      return res.data.inbox;
    },
    { enabled: !!token }
  );
};
